import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "title", "content", "error", "loading", "acceptText", "declineText", "onAccept", "onDecline"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Button, ModalWindow, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var DEFAULT_ACCEPT_TEXT = 'Ок';
export var DEFAULT_DECLINE_TEXT = 'Отмена';

/**
 * Dialog - диалог запроса подтверждения у пользователя в виде модального окна.
 * Предполагается что при открытии (open === true) будут переданны все необходимые параметры для отображения
 * и реакции на действия (onAccept, onDecline).
 * Закрытие диалога приравнивается к Отмене
 */
export var Dialog = function Dialog(props) {
  var open = props.open,
    title = props.title,
    content = props.content,
    error = props.error,
    loading = props.loading,
    _props$acceptText = props.acceptText,
    acceptText = _props$acceptText === void 0 ? DEFAULT_ACCEPT_TEXT : _props$acceptText,
    _props$declineText = props.declineText,
    declineText = _props$declineText === void 0 ? DEFAULT_DECLINE_TEXT : _props$declineText,
    onAccept = props.onAccept,
    onDecline = props.onDecline,
    rest = _objectWithoutProperties(props, _excluded);
  var isDesktop = useDeviceType() === 'desktop';
  var TextComponent = isDesktop ? UIText2 : UIText1;
  var Content = typeof content === 'string' && /*#__PURE__*/_jsx(TextComponent, {
    children: content
  });
  var Actions = /*#__PURE__*/_jsxs(_Fragment, {
    children: [error && /*#__PURE__*/_jsx("div", {
      className: styles['error'],
      children: /*#__PURE__*/_jsx(TextComponent, {
        color: "error_100",
        children: error
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['actions'],
      children: [/*#__PURE__*/_jsx(Button, {
        theme: "fill_primary",
        size: isDesktop ? 'XS' : 'M',
        fullWidth: !isDesktop,
        onClick: onAccept,
        loading: loading,
        "data-testid": "confirmDialogAccept",
        type: "button",
        children: acceptText
      }), /*#__PURE__*/_jsx(Button, {
        theme: isDesktop ? 'fill_white_primary' : 'fill_secondary',
        size: isDesktop ? 'XS' : 'M',
        fullWidth: !isDesktop,
        onClick: onDecline,
        "data-testid": "confirmDialogDecline",
        type: "button",
        children: declineText
      })]
    })]
  });
  return /*#__PURE__*/_jsx(ModalWindow, _objectSpread({
    open: open,
    escape: false,
    outside: false,
    maxWidth: 448,
    size: "XS",
    title: title,
    footer: Actions,
    content: Content,
    onClose: onDecline
  }, rest));
};